module.exports = __webpack_public_path__ + "img/cgal-04.bbed54a5.jpg";